import { css } from '@emotion/css';
import { fontStyle } from '@/css/resources/mixins.css';
import { cssObj } from '@/css/resources/functions.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fontStyle({
			...styles?.typography,
			textAlign: styles?.textAlignment,
			color: styles?.color,
		}),
		{
			p: {
				fontSize: 'inherit',
				lineHeight: 'inherit',
				margin: 'inherit',
			},
		}
	);

const getStyles = (styles) => css(getDynamicStyles(styles));

export { getStyles };
